import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

export default function ShortRedirect() {
  const { code } = useParams();

  useEffect(() => {
    window.location.replace(`https://apiportal.mbsays.com/public/api/s/${code}`);
  }, [code]);

  return <div style={{ padding: 24 }}>Yönlendiriliyor...</div>;
}
